import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { Translate } from "react-localize-redux";
import MaskInput from "react-maskinput";
import {
	BonusButton,
	BonusWrapper,
	Box,
	BoxTitle,
	Content,
	FailureImg,
	Feature,
	FeatureTitleBox,
	Logo,
	MaskedInput,
	Navigation,
	NavigationItem,
	NoBonusButton,
	Page,
	PaymentImg,
	PaymentWrapper,
	ResultContent,
	ResultText,
	StakeInput,
	SuccessImg,
	Title,
} from "../baseItems";
import Base from "./base";
import SMSInput from "./smsInput";
export default class Thorpay extends Base {
	goForward(step) {
		const newStep = step + 1,
			{ stake, selectedCurrency, smsDemand } = this.state,
			{ selectedDeposit } = this.props;
		const currency = selectedDeposit.currencies.find(
			(item) => item.currency == selectedCurrency
		);
		switch (newStep) {
			case 2: {
				if (!this.checkRequiredFields()) {
					return;
				}

				if (stake < currency.deposit.min) {
					this.props.showAlert({
						type: "error",
						msg: "STAKE_RANGE_WARNING_MIN",
						title: "ERROR",
					});
					return;
				}
				if (stake > currency.deposit.max) {
					this.props.showAlert({
						type: "error",
						msg: "STAKE_RANGE_WARNING_MAX",
						title: "ERROR",
					});
					return;
				}
				this.getAvailableBonuses(newStep);
				break;
			}
			case 5: {
				this.onFinish();
				break;
			}
			default:
				this.setState({
					currentStep: newStep,
				});
		}
	}

	onSendSms = (smsCode) => {
		this.props.externalFunc.getSms(
			{
				smsCode,
				referenceCode: this.state.thorpayReferenceCode,
			},
			this.onCheckPaymentStatus
		);
	};

	onSetSmsDemand = (smsDemand) => {
		this.setState({ smsDemand });
	};

	onCheckPaymentStatus = () => {
		this.props.externalFunc.paymentStatus(
			{
				referenceCode: this.state.thorpayReferenceCode,
				cardNumber: this.state.cardNumber.replaceAll("/", ""),
			},
			(resData) => {
				//Pending
				if (resData.code === "PENDING") {
					this.onCheckPaymentStatus();
				} else if (resData.code === "OK") {
					this.setState({
						showSmsWindow: false,
						showSuccessWindow: true,
					});
				} else {
					this.setState({
						showSmsWindow: false,
						showFailWindow: true,
						errorMsg: resData.message.ResultMessage || "ERROR_OCCURED",
					});
				}
			}
		);
	};

	finishDeposit = (data) => {
		const { smsDemand } = this.state;

		if (data.code === "OK") {
			if (smsDemand) {
				this.setState({
					currentStep: 5,
					thorpayReferenceCode: data.referenceCode,
					showSmsWindow: true,
				});
			} else {
				this.setState({
					currentStep: 5,
					thorpayReferenceCode: data.referenceCode,
					showSuccessWindow: true,
				});
			}
		} else {
			this.props.showAlert({
				type: "error",
				msg: data.message || "ERROR_OCCURED",
				title: "ERROR",
			});
		}
	};

	getThorpayCardType = (cardNumber) => {
		//FOR TESTING PURPOSES
		if ((cardNumber = "1111/2222/3333/4444")) {
			return "10";
		}
		let cardType = this.getCardType(cardNumber);
		return cardType && cardType === "visa" ? "20" : cardType === "mastercard" ? "10" : "30";
	};

	onFinish() {
		//validations
		const {
			cardHolder,
			cardNumber,
			cvv,
			expirationDate,
			stake,
			selectedCurrency,
			claimsBonus,
			selectedBonus,
		} = this.state;
		if (
			cvv !== "132" &&
			(!this.checkHolderName(cardHolder) ||
				!this.checkCvv(cvv) ||
				!this.checkExpirationDate(expirationDate) ||
				!this.checkCreditCardNumber(cardNumber))
		) {
			this.props.showAlert({
				type: "error",
				msg: "ALL_FIELDS_WARNING",
				title: "ERROR",
			});
		} else {
			const splitedCardNumber = cardNumber.split("/"),
				splitedDate = expirationDate.split("/"),
				cardType = this.getThorpayCardType(cardNumber),
				cardObj = {
					"cardNumber1": splitedCardNumber[0],
					"cardNumber2": splitedCardNumber[1],
					"cardNumber3": splitedCardNumber[2],
					"cardNumber4": splitedCardNumber[3],
					"cardMonth": splitedDate[0],
					"cardYear": splitedDate[1],
					"cardSecurityNum": cvv,
					"cardOwnerName": cardHolder,
					"cardType": cardType,
					"amount": stake,
					"currency": selectedCurrency,
					"language": this.getActiveLanguageCode(),
				};

			if (claimsBonus) {
				cardObj["claimsBonus"] = claimsBonus;
				cardObj["bonusId"] = selectedBonus.id;
			}
			this.props.externalFunc.depositThorpay(
				{
					...cardObj,
				},
				this.finishDeposit
			);
		}
	}

	getStep3(translate) {
		return (
			<Content>
				<Box>
					<BoxTitle>{translate("CARD_HOLDER")}</BoxTitle>
					<StakeInput
						align="left"
						type="text"
						placeholder="...................."
						onChange={this.onEnterValue.bind(this, "cardHolder")}
					/>
				</Box>
				<Box>
					<BoxTitle>{translate("CREDIT_CARD")}</BoxTitle>
					<MaskedInput>
						<MaskInput
							alwaysShowMask={window.IS_MARS ? true : false}
							maskChar="."
							mask="0000/0000/0000/0000"
							onChange={this.onEnterValue.bind(this, "cardNumber")}
						/>
					</MaskedInput>
				</Box>
				<Box>
					<BoxTitle>{translate("EXPIRY_DAY")}</BoxTitle>
					<MaskedInput>
						<MaskInput
							alwaysShowMask={window.IS_MARS ? true : false}
							maskChar="."
							mask="00/0000"
							onChange={this.onEnterValue.bind(this, "expirationDate")}
						/>
					</MaskedInput>
				</Box>
				<Box>
					<BoxTitle>{translate("CVV")}</BoxTitle>
					<MaskedInput>
						<MaskInput
							alwaysShowMask={window.IS_MARS ? true : false}
							maskChar="."
							mask="000"
							onChange={this.onEnterValue.bind(this, "cvv")}
						/>
					</MaskedInput>
				</Box>
			</Content>
		);
	}

	getStep4(translate) {
		const { smsDemand } = this.state;
		return (
			<Fragment>
				<Content>
					<BonusWrapper
						isBonusSelected={smsDemand}
						onClick={this.onSetSmsDemand.bind(this, true)}>
						<BonusButton> {translate("WITH_SMS")} </BonusButton>
					</BonusWrapper>

					<NoBonusButton
						isBonusSelected={!smsDemand}
						onClick={this.onSetSmsDemand.bind(this, false)}>
						{translate("WITHOUT_SMS")}{" "}
					</NoBonusButton>
					{/* <NoBonusButton onClick={this.onCheckPaymentStatus}>{translate("WITHOUT_SMS")} </NoBonusButton> */}
				</Content>
			</Fragment>
		);
	}

	getStep5(translate) {
		const { selectedDeposit } = this.props,
			{ externalUrl, showSmsWindow, showFailWindow, showSuccessWindow, showSelectionWindow } =
				this.state;
		return (
			<Fragment>
				{showSmsWindow && (
					<Content>
						<SMSInput
							ref={(x) => (this.smsInput = x)}
							title={translate("THORPAY_SMS_INPUT")}
							buttonText={translate("SEND_CODE")}
							onSendCode={this.onSendSms}></SMSInput>
					</Content>
				)}
				{showSuccessWindow && (
					<Content>
						<ResultContent>
							<SuccessImg></SuccessImg>
							<ResultText>{translate("PAYMENT_APPROVED")}</ResultText>
						</ResultContent>
					</Content>
				)}
				{showFailWindow && (
					<Content>
						<ResultContent>
							<FailureImg></FailureImg>
							<ResultText>{translate("PAYMENT_REJECTED")}</ResultText>
						</ResultContent>
					</Content>
				)}
			</Fragment>
		);
	}

	renderNavigationButtons(currentStep, canForward, translate) {
		const navigationBtnsContainer = document.getElementById("navigation-btns");
		if (!navigationBtnsContainer) return null;

		const navigations = (
			<Navigation>
				{currentStep !== 5 && (
					<NavigationItem
						back={true}
						onClick={
							currentStep === 1
								? this.onBackToDepositPage
								: currentStep === 2
									? this.goBack.bind(this, 1)
									: this.goBack.bind(this, currentStep - 1)
						}>
						{translate("BACK", null, { renderInnerHtml: true })}
					</NavigationItem>
				)}
				{currentStep < 5 ? (
					<NavigationItem
						filled={canForward}
						onClick={this.goForward.bind(this, currentStep)}>
						{translate("FORWARD", null, { renderInnerHtml: true })}
					</NavigationItem>
				) : null}
			</Navigation>
		);

		return ReactDOM.createPortal(navigations, navigationBtnsContainer);
	}

	render() {
		const { currentStep, canForward } = this.state,
			{ selectedDeposit } = this.props;
		return (
			<Translate>
				{({ translate }) => (
					<PaymentWrapper>
						<PaymentImg></PaymentImg>
						<Page>
							<Title>
								<Logo
									src={selectedDeposit.logo}
									insideLogoHeight={
										selectedDeposit.insideLogoHeight
											? selectedDeposit.insideLogoHeight
											: "30px"
									}></Logo>
								<FeatureTitleBox>
									<Feature>
										{selectedDeposit.logoName
											? selectedDeposit.logoName
											: selectedDeposit.name}
									</Feature>
									<Feature bold={true}>{selectedDeposit.bonus}</Feature>
									<Feature bold={true}>{selectedDeposit.feature}</Feature>
								</FeatureTitleBox>
							</Title>
							{currentStep === 1 && this.getStep1(translate)}
							{currentStep === 2 && this.getStep2(translate)}
							{currentStep === 3 && this.getStep3(translate)}
							{currentStep === 4 && this.getStep4(translate)}
							{currentStep === 5 && this.getStep5(translate)}
						</Page>
						{this.renderNavigationButtons(currentStep, canForward, translate)}
					</PaymentWrapper>
				)}
			</Translate>
		);
	}
}
